// @flow
import { Layout } from 'antd';
import { ConnectionModeSelection } from '../../components/ConnectionMode/ConnectionModeSelection';
import { DeviceSelectionFooter } from '../../components/DeviceSelectionFooter';
import SubTitle from 'bil-front-commons/lib/components/SubTitle';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BILLoader from '../../components/BILLoader/BILLoader';
import BILPageHeader from '../../components/BILPageHeader';
import LanguagePanel from '../../components/LanguagePanel/LanguagePanel';
import { checkUserDevice, scrollToTop } from '../../hooks/useWindowDimensions';
import { handleLanguageChange } from '../../utils/LanguageUtils';
import './index.less';

//// JS MAIN
const DeviceSelection = (props) => {

   const { language, paymentInfo } = props;
   const [isLoading, setLoading] = useState(false);
   const isRunningOnMobile = checkUserDevice();
   const isAppToAppScaDevice = paymentInfo.appToAppScaDevice ? true : false;
   
   useEffect(() => {
      scrollToTop()
   }, []);

   if (!isLoading) {
      return (
         <div>
            <Layout className="device-selection">
               <BILPageHeader
                  setLoading={setLoading}
                  {...props}
               />
               {isRunningOnMobile ? null :
                  <LanguagePanel
                     right={true}
                     onLanguageChange={(lang) => handleLanguageChange(props, lang, setLoading)}
                     {...props}
                  />}
               <SubTitle text="connection-mode.selectYours" />
               <ConnectionModeSelection
                  isAppToAppScaDevice={isAppToAppScaDevice}
                  onSelect={(mode) => handleSelectMode(props, mode)}
               />
               <DeviceSelectionFooter language={language} />
            </Layout>
         </div>
      );
   } else {
      return (
         <div className="intl-spinner-container">
            <BILLoader />
         </div>
      );
   }
}

//// JS FUNCTIONS
function handleSelectMode(props, mode) {
   const { history, language } = props;

   history.push(`/${language}/luxtrust/${mode}`);
};

//// JS REDUX
const mapStateToProps = (state) => ({
   language: state.intl.locale,
   paymentInfo: state.paymentInfoParam.paymentInfo
});


export default connect(mapStateToProps)(DeviceSelection);
